export type Index = number
export type Indexed<T> = [Index, T]

export const index = <T>(
  list: T[]
) => list.map(
    (value, idx) => [idx, value] as Indexed<T>
  )
